import {
  faTimes,
  faSortAlphaDown,
  faSortAlphaUp,
  faHeart as fasHeart,
  faEdit,
  faCopy,
  faTag,
  faHistory
} from '@fortawesome/pro-light-svg-icons';

import {
  faCircleNotch,
  faChevronLeft,
  faHeart as falHeart,
  faList,
  faCog,
  faInfoCircle,
  faUsers
} from '@fortawesome/pro-solid-svg-icons';

import {
  faSearch,
  faFileUpload,
} from '@fortawesome/pro-regular-svg-icons';

export const APP_ICONS = [
  faSearch,
  faCircleNotch,
  faChevronLeft,
  faTimes,
  faSortAlphaDown,
  faSortAlphaUp,
  fasHeart,
  falHeart,
  faList,
  faFileUpload,
  faEdit,
  faCog,
  faCopy,
  faTag,
  faHistory,
  faInfoCircle,
  faUsers
];
